<template>
    <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important">
            <v-card-text class="px-0 ">
                    <v-row class="px-0 py-1">
                        <v-col cols="12" class="px-0" align="center" justify="center">
                            <h1>{{ $t('upload_files.manage_files') }} ({{id}})</h1>
                            <v-col cols="9" class="px-0">
                                <v-progress-linear
                                    v-model="progress"
                                    height="35"
                                    color="secondary"
                                    class="pl-2 pr-0" 
                                >
                                    <strong>{{ Math.ceil(progress) }}%</strong>
                                </v-progress-linear>
                                <i style="font-size:14px"><v-icon color="secondary">info</v-icon>{{ $t('upload_files.info') }}</i>
                            </v-col>
                        </v-col>
                    </v-row>
                    <v-form ref="form" lazy-validation @submit.prevent="save">
                        <v-row class="px-0 py-0" justify="center" align="center">
                            <v-checkbox v-model="required_files.petition" class="ml-8 mb-1" color="blue_accent"></v-checkbox>
                            <v-col :cols="form_size" class="py-0 px-0">
                                <v-file-input prepend-icon="cloud_upload"  class="cloud_upload px-0" :clearable="false" v-model="files.petition"  accept="*" :label="$t('upload_files.petition_file')" :disabled="!required_files.petition || current_files.petition"></v-file-input>
                            </v-col>
                            <v-col cols="1">
                                <v-row>
                                    <v-btn outlined color="blue_accent" small class="px-0 mx-1" style="min-width:25px !important" @click="getFile('petition')" :disabled="current_files.petition == false"><v-icon small >download</v-icon></v-btn>
                                    <v-btn outlined color="red" small class="px-0 mx-1" style="min-width:25px !important" :disabled="current_files.petition == false" @click="deleteFile('petition')"><v-icon  small>delete</v-icon></v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="px-0 py-0" justify="center" align="center">
                            <v-checkbox v-model="required_files.invoice" class="ml-8 mb-1" color="blue_accent"></v-checkbox>
                            <v-col :cols="form_size" class="py-0 px-0">
                                <v-file-input prepend-icon="cloud_upload"  class="cloud_upload" :clearable="false" v-model="files.invoice" accept="*" :label="$t('upload_files.invoice_file')" :disabled="!required_files.invoice || current_files.invoice"></v-file-input>
                            </v-col>
                            <v-col cols="1">
                                <v-row>
                                    <v-btn outlined color="blue_accent" small class="px-0 mx-1" style="min-width:25px !important" @click="getFile('invoice')" :disabled="current_files.invoice == false"><v-icon small>download</v-icon></v-btn>
                                    <v-btn outlined color="red" small class="px-0 mx-1" style="min-width:25px !important" :disabled="current_files.invoice == false" @click="deleteFile('invoice')"><v-icon  small>delete</v-icon></v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="px-0 py-0" justify="center" align="center">
                            <v-checkbox v-model="required_files.packing_list" class="ml-8 mb-1" color="blue_accent"></v-checkbox>
                            <v-col :cols="form_size" class="py-0 px-0">
                                   <v-file-input prepend-icon="cloud_upload"  class="cloud_upload" :clearable="false" v-model="files.packing_list" accept="*" :label="$t('upload_files.packing_list_file')" :disabled="!required_files.packing_list || current_files.packing_list"></v-file-input>
                            </v-col>
                            <v-col cols="1" >
                                <v-row>
                                    <v-btn outlined color="blue_accent" small class="px-0 mx-1" style="min-width:25px !important" @click="getFile('packing_list')" :disabled="current_files.packing_list == false"><v-icon small>download</v-icon></v-btn>
                                    <v-btn outlined color="red" small class="px-0 mx-1" style="min-width:25px !important" :disabled="current_files.packing_list == false" @click="deleteFile('packing_list')"><v-icon  small>delete</v-icon></v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="px-0 py-0" justify="center" align="center">
                            <v-checkbox v-model="required_files.doda" class="ml-8 mb-1" color="blue_accent"></v-checkbox>
                            <v-col :cols="form_size" class="py-0 px-0">
                                   <v-file-input prepend-icon="cloud_upload"  class="cloud_upload" :clearable="false" v-model="files.doda" accept="*" :label="$t('upload_files.doda')" :disabled="!required_files.doda || current_files.doda"></v-file-input>
                            </v-col>
                            <v-col cols="1" >
                                <v-row>
                                    <v-btn outlined color="blue_accent" small class="px-0 mx-1" style="min-width:25px !important" @click="getFile('doda')" :disabled="current_files.doda == false"><v-icon small>download</v-icon></v-btn>
                                    <v-btn outlined color="red" small class="px-0 mx-1" style="min-width:25px !important" :disabled="current_files.doda == false" @click="deleteFile('doda')"><v-icon  small>delete</v-icon></v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="px-0 py-0" justify="center" align="center">
                            <v-checkbox v-model="required_files.acuse_cove" class="ml-8 mb-1" color="blue_accent"></v-checkbox>
                            <v-col :cols="form_size" class="py-0 px-0">
                                   <v-file-input prepend-icon="cloud_upload"  class="cloud_upload" :clearable="false" v-model="files.acuse_cove" accept="*" :label="$t('upload_files.acuse_cove')" :disabled="!required_files.acuse_cove || current_files.acuse_cove"></v-file-input>
                            </v-col>
                            <v-col cols="1" >
                                <v-row>
                                    <v-btn outlined color="blue_accent" small class="px-0 mx-1" style="min-width:25px !important" @click="getFile('acuse_cove')" :disabled="current_files.acuse_cove == false"><v-icon small>download</v-icon></v-btn>
                                    <v-btn outlined color="red" small class="px-0 mx-1" style="min-width:25px !important" :disabled="current_files.acuse_cove == false" @click="deleteFile('acuse_cove')"><v-icon  small>delete</v-icon></v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="px-0 py-0" justify="center" align="center">
                            <v-checkbox v-model="required_files.edocument" class="ml-8 mb-1" color="blue_accent"></v-checkbox>
                            <v-col :cols="form_size" class="py-0 px-0">
                                   <v-file-input prepend-icon="cloud_upload"  class="cloud_upload" :clearable="false" v-model="files.edocument" accept="*" :label="$t('upload_files.e-document')" :disabled="!required_files.edocument || current_files.edocument"></v-file-input>
                            </v-col>
                            <v-col cols="1" >
                                <v-row>
                                    <v-btn outlined color="blue_accent" small class="px-0 mx-1" style="min-width:25px !important" @click="getFile('edocument')" :disabled="current_files.edocument == false"><v-icon small>download</v-icon></v-btn>
                                    <v-btn outlined color="red" small class="px-0 mx-1" style="min-width:25px !important" :disabled="current_files.edocument == false" @click="deleteFile('edocument')"><v-icon  small>delete</v-icon></v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="px-0 py-0" justify="center" align="center">
                            <v-checkbox v-model="required_files.simplified_petition" class="ml-8 mb-1" color="blue_accent"></v-checkbox>
                            <v-col :cols="form_size" class="py-0 px-0">
                                   <v-file-input prepend-icon="cloud_upload"  class="cloud_upload" :clearable="false" v-model="files.simplified_petition" accept="*" :label="$t('upload_files.simplified_petition')" :disabled="!required_files.simplified_petition || current_files.simplified_petition"></v-file-input>
                            </v-col>
                            <v-col cols="1" >
                                <v-row>
                                    <v-btn outlined color="blue_accent" small class="px-0 mx-1" style="min-width:25px !important" @click="getFile('simplified_petition')" :disabled="current_files.simplified_petition == false"><v-icon small>download</v-icon></v-btn>
                                    <v-btn outlined color="red" small class="px-0 mx-1" style="min-width:25px !important" :disabled="current_files.simplified_petition == false" @click="deleteFile('simplified_petition')"><v-icon  small>delete</v-icon></v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="px-0 py-0" justify="center" align="center">
                            <v-checkbox v-model="required_files.acuse_edocument" class="ml-8 mb-1" color="blue_accent"></v-checkbox>
                            <v-col :cols="form_size" class="py-0 px-0">
                                   <v-file-input prepend-icon="cloud_upload"  class="cloud_upload" :clearable="false" v-model="files.acuse_edocument" accept="*" :label="$t('upload_files.acuse_e-document')" :disabled="!required_files.acuse_edocument || current_files.acuse_edocument"></v-file-input>
                            </v-col>
                            <v-col cols="1" >
                                <v-row>
                                    <v-btn outlined color="blue_accent" small class="px-0 mx-1" style="min-width:25px !important" @click="getFile('acuse_edocument')" :disabled="current_files.acuse_edocument == false"><v-icon small>download</v-icon></v-btn>
                                    <v-btn outlined color="red" small class="px-0 mx-1" style="min-width:25px !important" :disabled="current_files.acuse_edocument == false" @click="deleteFile('acuse_edocument')"><v-icon  small>delete</v-icon></v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="px-0 py-0" justify="center" align="center">
                            <v-checkbox v-model="required_files.rectification_petition" class="ml-8 mb-1" color="blue_accent"></v-checkbox>
                            <v-col :cols="form_size" class="py-0 px-0">
                                   <v-file-input prepend-icon="cloud_upload"  class="cloud_upload" :clearable="false" v-model="files.rectification_petition" accept="*" :label="$t('upload_files.rectification_petition')" :disabled="!required_files.rectification_petition || current_files.rectification_petition"></v-file-input>
                            </v-col>
                            <v-col cols="1" >
                                <v-row>
                                    <v-btn outlined color="blue_accent" small class="px-0 mx-1" style="min-width:25px !important" @click="getFile('rectification_petition')" :disabled="current_files.rectification_petition == false"><v-icon small>download</v-icon></v-btn>
                                    <v-btn outlined color="red" small class="px-0 mx-1" style="min-width:25px !important" :disabled="current_files.rectification_petition == false" @click="deleteFile('rectification_petition')"><v-icon  small>delete</v-icon></v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="px-0 py-0" justify="center" align="center">
                            <v-checkbox v-model="required_files.rrnas" class="ml-8 mb-1" color="blue_accent"></v-checkbox>
                            <v-col :cols="form_size" class="py-0 px-0">
                                   <v-file-input prepend-icon="cloud_upload"  class="cloud_upload" :clearable="false" v-model="files.rrnas" accept="*" :label="$t('upload_files.rrnas')" :disabled="!required_files.rrnas || current_files.rrnas"></v-file-input>
                            </v-col>
                            <v-col cols="1" >
                                <v-row>
                                    <v-btn outlined color="blue_accent" small class="px-0 mx-1" style="min-width:25px !important" @click="getFile('rrnas')" :disabled="current_files.rrnas == false"><v-icon small>download</v-icon></v-btn>
                                    <v-btn outlined color="red" small class="px-0 mx-1" style="min-width:25px !important" :disabled="current_files.rrnas == false" @click="deleteFile('rrnas')"><v-icon  small>delete</v-icon></v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="px-0 py-0" justify="center" align="center">
                            <v-checkbox v-model="required_files.expense_account" class="ml-8 mb-1" color="blue_accent"></v-checkbox>
                            <v-col :cols="form_size" class="py-0 px-0">
                                   <v-file-input prepend-icon="cloud_upload"  class="cloud_upload" :clearable="false" v-model="files.expense_account" accept="*" :label="$t('upload_files.expense_account')" :disabled="!required_files.expense_account || current_files.expense_account"></v-file-input>
                            </v-col>
                            <v-col cols="1" >
                                <v-row>
                                    <v-btn outlined color="blue_accent" small class="px-0 mx-1" style="min-width:25px !important" @click="getFile('expense_account')" :disabled="current_files.expense_account == false"><v-icon small>download</v-icon></v-btn>
                                    <v-btn outlined color="red" small class="px-0 mx-1" style="min-width:25px !important" :disabled="current_files.expense_account == false" @click="deleteFile('expense_account')"><v-icon  small>delete</v-icon></v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="px-0 py-0" justify="center" align="center">
                            <v-checkbox v-model="required_files.virtual_transfer_notice" class="ml-8 mb-1" color="blue_accent"></v-checkbox>
                            <v-col :cols="form_size" class="py-0 px-0">
                                   <v-file-input prepend-icon="cloud_upload"  class="cloud_upload" :clearable="false" v-model="files.virtual_transfer_notice" accept="*" :label="$t('upload_files.virtual_transfer_notice')" :disabled="!required_files.virtual_transfer_notice || current_files.virtual_transfer_notice"></v-file-input>
                            </v-col>
                            <v-col cols="1" >
                                <v-row>
                                    <v-btn outlined color="blue_accent" small class="px-0 mx-1" style="min-width:25px !important" @click="getFile('virtual_transfer_notice')" :disabled="current_files.virtual_transfer_notice == false"><v-icon small>download</v-icon></v-btn>
                                    <v-btn outlined color="red" small class="px-0 mx-1" style="min-width:25px !important" :disabled="current_files.virtual_transfer_notice == false" @click="deleteFile('virtual_transfer_notice')"><v-icon  small>delete</v-icon></v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="px-0 py-0" justify="center" align="center">
                            <v-checkbox v-model="required_files.consolidated_notice" class="ml-8 mb-1" color="blue_accent"></v-checkbox>
                            <v-col :cols="form_size" class="py-0 px-0">
                                   <v-file-input prepend-icon="cloud_upload"  class="cloud_upload" :clearable="false" v-model="files.consolidated_notice" accept="*" :label="$t('upload_files.consolidated_notice')" :disabled="!required_files.consolidated_notice || current_files.consolidated_notice"></v-file-input>
                            </v-col>
                            <v-col cols="1" >
                                <v-row>
                                    <v-btn outlined color="blue_accent" small class="px-0 mx-1" style="min-width:25px !important" @click="getFile('consolidated_notice')" :disabled="current_files.consolidated_notice == false"><v-icon small>download</v-icon></v-btn>
                                    <v-btn outlined color="red" small class="px-0 mx-1" style="min-width:25px !important" :disabled="current_files.consolidated_notice == false" @click="deleteFile('consolidated_notice')"><v-icon  small>delete</v-icon></v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="px-0 py-0" justify="center" align="center">
                            <v-checkbox v-model="required_files.certificate_of_origin_of_merchandise" class="ml-8 mb-1" color="blue_accent"></v-checkbox>
                            <v-col :cols="form_size" class="py-0 px-0">
                                   <v-file-input prepend-icon="cloud_upload"  class="cloud_upload" :clearable="false" v-model="files.certificate_of_origin_of_merchandise" accept="*" :label="$t('upload_files.certificate_of_origin_of_merchandise')" :disabled="!required_files.certificate_of_origin_of_merchandise || current_files.certificate_of_origin_of_merchandise"></v-file-input>
                            </v-col>
                            <v-col cols="1" >
                                <v-row>
                                    <v-btn outlined color="blue_accent" small class="px-0 mx-1" style="min-width:25px !important" @click="getFile('certificate_of_origin_of_merchandise')" :disabled="current_files.certificate_of_origin_of_merchandise == false"><v-icon small>download</v-icon></v-btn>
                                    <v-btn outlined color="red" small class="px-0 mx-1" style="min-width:25px !important" :disabled="current_files.certificate_of_origin_of_merchandise == false" @click="deleteFile('certificate_of_origin_of_merchandise')"><v-icon  small>delete</v-icon></v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="px-0 py-0" justify="center" align="center">
                            <v-checkbox v-model="required_files.manifestation_value" class="ml-8 mb-1" color="blue_accent"></v-checkbox>
                            <v-col :cols="form_size" class="py-0 px-0">
                                   <v-file-input prepend-icon="cloud_upload"  class="cloud_upload" :clearable="false" v-model="files.manifestation_value" accept="*" :label="$t('upload_files.manifestation_value')" :disabled="!required_files.manifestation_value || current_files.manifestation_value"></v-file-input>
                            </v-col>
                            <v-col cols="1" >
                                <v-row>
                                    <v-btn outlined color="blue_accent" small class="px-0 mx-1" style="min-width:25px !important" @click="getFile('manifestation_value')" :disabled="current_files.manifestation_value == false"><v-icon small>download</v-icon></v-btn>
                                    <v-btn outlined color="red" small class="px-0 mx-1" style="min-width:25px !important" :disabled="current_files.manifestation_value == false" @click="deleteFile('manifestation_value')"><v-icon  small>delete</v-icon></v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="px-0 py-0" justify="center" align="center">
                            <v-checkbox v-model="required_files.spreadsheet" class="ml-8 mb-1" color="blue_accent"></v-checkbox>
                            <v-col :cols="form_size" class="py-0 px-0">
                                   <v-file-input prepend-icon="cloud_upload"  class="cloud_upload" :clearable="false" v-model="files.spreadsheet" accept="*" :label="$t('upload_files.spreadsheet')" :disabled="!required_files.spreadsheet || current_files.spreadsheet"></v-file-input>
                            </v-col>
                            <v-col cols="1" >
                                <v-row>
                                    <v-btn outlined color="blue_accent" small class="px-0 mx-1" style="min-width:25px !important" @click="getFile('spreadsheet')" :disabled="current_files.spreadsheet == false"><v-icon small>download</v-icon></v-btn>
                                    <v-btn outlined color="red" small class="px-0 mx-1" style="min-width:25px !important" :disabled="current_files.spreadsheet == false" @click="deleteFile('spreadsheet')"><v-icon  small>delete</v-icon></v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="px-0 py-0" justify="center" align="center">
                            <v-checkbox v-model="required_files.cove" class="ml-8 mb-1" color="blue_accent"></v-checkbox>
                            <v-col :cols="form_size" class="py-0 px-0">
                                   <v-file-input prepend-icon="cloud_upload"  class="cloud_upload" :clearable="false" v-model="files.cove" accept="*" :label="$t('upload_files.cove')" :disabled="!required_files.cove || current_files.cove"></v-file-input>
                            </v-col>
                            <v-col cols="1" >
                                <v-row>
                                    <v-btn outlined color="blue_accent" small class="px-0 mx-1" style="min-width:25px !important" @click="getFile('cove')" :disabled="current_files.cove == false"><v-icon small>download</v-icon></v-btn>
                                    <v-btn outlined color="red" small class="px-0 mx-1" style="min-width:25px !important" :disabled="current_files.cove == false" @click="deleteFile('cove')"><v-icon  small>delete</v-icon></v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="px-0 py-0" justify="center" align="center">
                            <v-checkbox v-model="required_files.validation_links" class="ml-8 mb-1" color="blue_accent"></v-checkbox>
                            <v-col :cols="form_size" class="py-0 px-0">
                                   <v-file-input prepend-icon="cloud_upload"  class="cloud_upload" :clearable="false" v-model="files.validation_links" accept="*" :label="$t('upload_files.validation_links')" :disabled="!required_files.validation_links || current_files.validation_links"></v-file-input>
                            </v-col>
                            <v-col cols="1" >
                                <v-row>
                                    <v-btn outlined color="blue_accent" small class="px-0 mx-1" style="min-width:25px !important" @click="getFile('validation_links')" :disabled="current_files.validation_links == false"><v-icon small>download</v-icon></v-btn>
                                    <v-btn outlined color="red" small class="px-0 mx-1" style="min-width:25px !important" :disabled="current_files.validation_links == false" @click="deleteFile('validation_links')"><v-icon  small>delete</v-icon></v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="px-0 py-0" justify="center" align="center">
                            <v-checkbox v-model="required_files.other" class="ml-8 mb-1" color="blue_accent"></v-checkbox>
                            <v-col :cols="form_size" class="py-0 px-0">
                                   <v-file-input prepend-icon="cloud_upload"  class="cloud_upload" :clearable="false" v-model="files.other" accept="*" :label="$t('upload_files.other')" :disabled="!required_files.other || current_files.other"></v-file-input>
                            </v-col>
                            <v-col cols="1" >
                                <v-row>
                                    <v-btn outlined color="blue_accent" small class="px-0 mx-1" style="min-width:25px !important" @click="getFile('other')" :disabled="current_files.other == false"><v-icon small>download</v-icon></v-btn>
                                    <v-btn outlined color="red" small class="px-0 mx-1" style="min-width:25px !important" :disabled="current_files.other == false" @click="deleteFile('other')"><v-icon  small>delete</v-icon></v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="px-0 py-0" justify="center" align="center">
                            <v-checkbox v-model="required_files.petition_customer" class="ml-8 mb-1" color="blue_accent"></v-checkbox>
                            <v-col :cols="form_size" class="py-0 px-0">
                                   <v-file-input prepend-icon="cloud_upload"  class="cloud_upload" :clearable="false" v-model="files.petition_customer" accept="*" :label="$t('upload_files.petition_customer')" :disabled="!required_files.petition_customer || current_files.petition_customer"></v-file-input>
                            </v-col>
                            <v-col cols="1" >
                                <v-row>
                                    <v-btn outlined color="blue_accent" small class="px-0 mx-1" style="min-width:25px !important" @click="getFile('petition_customer')" :disabled="current_files.petition_customer == false"><v-icon small>download</v-icon></v-btn>
                                    <v-btn outlined color="red" small class="px-0 mx-1" style="min-width:25px !important" :disabled="current_files.petition_customer == false" @click="deleteFile('petition_customer')"><v-icon  small>delete</v-icon></v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="px-0 py-0" justify="center" align="center">
                            <v-col cols="8" class="py-0 px-0">
                                <v-textarea v-model="observaciones" :label="$t('upload_files.observations')"></v-textarea>
                            </v-col>
                        </v-row>
                        <v-row class="px-0 py-0" justify="center" align="center">
                            <v-col cols="8" class="py-0 px-0">
                                <span class="font-weight-bold">{{ $t('upload_files.drawback') }}:</span>
                                <v-radio-group class="my-0" v-model="inconveniente" row style="max-height:33px !important">
                                    <v-radio :label="$t('upload_files.true')" value="1"></v-radio>
                                    <v-radio :label="$t('upload_files.false')" value="0"></v-radio>
                                </v-radio-group>
                            </v-col>
                        </v-row>
                    </v-form>

                    <br>
                    <br>

                    <v-row class="px-5 py-0" justify="center">
                        <v-col cols="8" align="right">
                            <v-btn class="right mx-3" @click="cancel">{{ $t('upload_files.cancel') }}</v-btn>
                            <v-btn class="right white_highlight--text mx-0" color="secondary" @click="save" v-permission="'i_digital_heritage.file'">{{ $t('upload_files.accept') }}</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
        </v-container>
        <v-dialog v-model="modalDelete" persistent max-width="90%">
            <v-card >
                <v-card-title class="justify-center">
                    <v-row align="center" justify="center">
                            <h2>
                                {{ $t('upload_files.modal.title') }}
                            </h2>
                    </v-row>
                    <v-btn color="secondary darken-1" small icon @click="modalDelete = false"><v-icon small>close</v-icon></v-btn>
                </v-card-title>
                <v-card-text>
                    
                    <v-row align="center" justify="center" class="py-3 my-3 text-center">
                        <v-col cols="12">
                            <h3>{{ $t('upload_files.modal.continue') }}</h3>
                        </v-col>
                    </v-row>
                    
                    <div class="d-flex">
                        <v-spacer></v-spacer>
                        <v-btn class="mx-3" text @click="modalDelete = false; currentDelete = ''">{{ $t('upload_files.modal.cancel') }}</v-btn>
                        <v-btn color="secondary" class="color" @click="deleteM">
                            {{ $t('upload_files.modal.delete') }}
                        </v-btn>
                        
                    </div>
                </v-card-text> 
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color">{{ snackbar.text }}</v-snackbar>
    </div>
</template>
<script>
import FileSaver from 'file-saver';

export default {
    computed: {
    },
    data(){
        return {
            id: this.$route.params.id,
            form_size: 7,
            modalDelete: false,
            observaciones: '',
            inconveniente: '0',
            files:{
                petition: [],
                invoice : [],
                packing_list : [],
                doda: [],
                acuse_cove: [],
                edocument: [],
                simplified_petition: [],
                acuse_edocument: [],
                rectification_petition: [],
                rrnas: [],
                expense_account: [],
                virtual_transfer_notice: [],
                consolidated_notice: [],
                certificate_of_origin_of_merchandise: [],
                manifestation_value: [],
                spreadsheet: [],
                cove: [],
                validation_links: [],
                other: [],
                petition_customer: []
            },
            current_files:{
                petition: false,
                invoice: false,
                packing_list: false,
                doda: false,
                acuse_cove: false,
                edocument: false,
                simplified_petition: false,
                acuse_edocument: false,
                rectification_petition: false,
                rrnas: false,
                expense_account: false,
                virtual_transfer_notice: false,
                consolidated_notice: false,
                certificate_of_origin_of_merchandise: false,
                manifestation_value: false,
                spreadsheet: false,
                cove: false,
                validation_links: false,
                other: false,
                petition_customer: false,
                petition_name: '',
                invoice_name: '',
                packing_list_name: '',
                doda_name: '',
                acuse_cove_name: '',
                edocument_name: '',
                simplified_petition_name: '',
                acuse_edocument_name: '',
                rectification_petition_name: '',
                rrnas_name: '',
                expense_account_name: '',
                virtual_transfer_notice_name: '',
                consolidated_notice_name: '',
                certificate_of_origin_of_merchandise_name: '',
                manifestation_value_name: '',
                spreadsheet_name: '',
                cove_name: '',
                validation_links_name: '',
                other_name: '',
                petition_customer_name: ''
            },
            required_files: {
                petition: true,
                invoice: true,
                packing_list: true,
                doda: true,
                acuse_cove: true,
                edocument: true,
                simplified_petition: true,
                acuse_edocument: true,
                rectification_petition: true,
                rrnas: true,
                expense_account: true,
                virtual_transfer_notice: true,
                consolidated_notice: true,
                certificate_of_origin_of_merchandise: true,
                manifestation_value: true,
                spreadsheet: true,
                cove: true,
                validation_links: true,
                other: true,
                petition_customer: true
            },
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            downloadCurrentFiles: [],
            currentDelete: '',
            progress: 0,
        }
    },
    mounted(){
        this.$store.state.module = "headers.manage_files";
        this.index();
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters);
        },
        index(){
            this.downloadCurrentFiles = [];
            this.$store.state.loaderProps.visible = false;
            const lsToken = localStorage.getItem("access_token");
            this.$http.get(this.$store.state.chronosApi + 'appointments/' + this.id + '/getFiles', {headers: {Authorization: lsToken}})
            .then((response) => {
                this.observaciones = response.data.dm.observations;
                this.downloadCurrentFiles = response.data.files;
                this.progress = 0;
                var number_files = 0;
                for (var prop in this.required_files) {
                    if(this.required_files[prop] == true) number_files += 1;
                }
                response.data.files.forEach((x) =>{
                    var tipo = x.name.substring(0, x.name.indexOf('-'));
                    if(number_files > 0) this.progress += 100/number_files;
                    this.current_files[tipo] = true;
                    this.current_files[tipo + '_name'] = x.name.substring(x.name.indexOf('-') + 1, x.name.length);
                    this.files[tipo] = new File(["foo"], x.name.substring(x.name.indexOf('-') + 1, x.name.length), {
                        type: "text/plain",
                    });    
                });
                if (response.data.dm.required_files != null && response.data.dm.required_files != undefined) this.required_files = JSON.parse(response.data.dm.required_files);
                if (response.data.dm.observations != null && response.data.dm.observations != undefined) this.observaciones = response.data.dm.observations;
                if (response.data.dm.inconvenient != null && response.data.dm.drawback != undefined) this.inconveniente = response.data.dm.inconvenient.toString();
            }).catch((error) => {
                console.log(error);
            }).finally(() => {
                this.$store.state.loaderProps.visible = false;
            });
        },
        save(){
            this.$store.state.loaderProps.visible = true;
            const formData = new FormData();

            formData.append('required_files', JSON.stringify(this.required_files));
            formData.append('observations', this.observaciones);
            formData.append('inconveniente', this.inconveniente);
            
            for(var prop in this.files){
                if(this.files[prop] != null && this.files[prop].type != 'text/plain') formData.append(prop, this.files[prop]);
            }
            // console.log([...formData]) // Print form data displaying all pr

            const lsToken = localStorage.getItem("access_token");
            this.$http.post(this.$store.state.chronosApi + 'uploadFiles/' + this.id, formData, {headers: {Authorization: lsToken}})
            .then(response => {
                if(response.status == 200){
                    this.snackbar = {
                        visible: true,
                        color: 'success2',
                        text: this.$t('upload_files.responses.ok')
                    }
                }
            }).catch((error) => {
                console.log(error);
                this.snackbar = {
                    visible: true,
                    color: 'red',
                    text: this.$t('upload_files.responses.error')
                }
            }).finally(() => {
                this.$store.state.loaderProps.visible = false;
            });
        },
        cancel(){
            this.$router.go(-1);
        },
        getFile(type){
            this.$store.state.loaderProps.visible = true;
            this.downloadCurrentFiles.forEach(x => {
                if(x.name.includes(type + '-')){    
                this.$store.state.loaderProps.visible = true;

                    this.$http.get(this.$store.state.chronosApi + 'getSingleFile/' + x.index, { responseType: 'blob'})
                    .then(response => {
                        FileSaver.saveAs(response.data, x.name)
                        this.$store.state.loaderProps.visible = false;
                    })
                }
            })

            this.$store.state.loaderProps.visible = false;
        },
        deleteFile(type){
            this.modalDelete = true;
            this.currentDelete = type;
        },
        deleteM(){
            const lsToken = localStorage.getItem("access_token");
            this.$store.state.loaderProps.visible = true;
            var index = null; 
            this.downloadCurrentFiles.forEach(x => {
                if(x.name.includes(this.currentDelete)){
                    index = x.index
                }
            });
            this.$http.delete(this.$store.state.chronosApi + 'appointments/' + index + '/deleteFile', {headers: {Authorization: lsToken}})
            .then(response => {
                if(response.status == 200){
                    this.modalDelete = false;
                    this.snackbar = {
                        visible: true,
                        color: 'success2',
                        text: this.$t('upload_files.responses.deleted')
                    }
                }
                this.current_files[this.currentDelete] = false;
                this.index();
            }).catch((error) => {
                console.log(error);
                this.snackbar = {
                    visible: true,
                    color: 'red',
                    text: this.$t('upload_files.responses.error')
                }
            }).finally(() => {
                this.$store.state.loaderProps.visible = false;
            });
        }
    },
    watch: {
        'required_files': {
            handler(/*newValue, oldValue */){  // here having access to the new and old value
                this.progress = 0;
                var number_files = 0;
                for (var prop in this.required_files) {
                    if(this.required_files[prop] == true) number_files += 1;
                }
                if(number_files > 0){
                    for (var pr in this.current_files) {
                        if((this.current_files[pr] == true && typeof this.current_files[pr] === "boolean") && this.required_files[pr] == true) this.progress += 100/number_files;
                    }
                }
            },
            deep: true,
            immediate: true
        },
        'progress': function(){
            if(this.progress > 100) this.progress = 100;
        }
    }
}
</script>

<style lang="scss">
.cloud_upload{
    button{
        color: #191970 !important;
    }
}

.color{
    color: white !important;
}
</style>